var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3164 4.92188H12.3594V3.52147L8.83791 0H1.64062V4.92188H0.683594V11.9219H1.64062V14H12.3594V11.9219H13.3164V4.92188ZM9.07812 1.40041L10.959 3.28125H9.07812V1.40041ZM2.46094 0.820312H8.25781V4.10156H11.5391V4.92188H2.46094V0.820312ZM11.5391 13.1797H2.46094V11.9219H11.5391V13.1797ZM12.4961 11.1016H1.50391V5.74219H12.4961V11.1016Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.10547H3.89648C4.58253 9.10547 5.14062 8.54738 5.14062 7.86133C5.14062 7.17528 4.58253 6.61719 3.89648 6.61719H2.67969V10.3359H3.5V9.10547ZM3.5 7.4375H3.89648C4.13019 7.4375 4.32031 7.62762 4.32031 7.86133C4.32031 8.09503 4.13019 8.28516 3.89648 8.28516H3.5V7.4375Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42188 8.69531V8.25781C8.42188 7.35312 7.68594 6.61719 6.78125 6.61719H5.96094V10.3359H6.78125C7.68594 10.3359 8.42188 9.60001 8.42188 8.69531ZM6.78125 7.4375C7.2336 7.4375 7.60156 7.80547 7.60156 8.25781V8.69531C7.60156 9.14766 7.2336 9.51562 6.78125 9.51562V7.4375Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1172 9.20117H10.9375V8.38086H10.1172V7.4375H11.3477V6.61719H9.29688V10.3359H10.1172V9.20117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.4ab08a6cf0b595896c58e6f383002cc4.svg";
export { ForwardRef as ReactComponent };